module.exports = __webpack_public_path__ + "img/cuixe-plant.274bca9a.png";